<template>
   <div class="input-container">
      <label v-if="props.positionlabel === 'left' && props.label">{{ props.label }}</label>
      <section class="input-flex">
         <p class="error" v-if="props.error">{{ errorMessage }}</p>
         <div class="input-wrapper" :class="claseDinamica" ref="wrapperRef">
            <label :for="props.name" class="input-label-top" v-if="props.positionlabel === 'top'">{{ props.label
               }}</label>
            <input ref="inputRef"  v-if="props.type === 'text'" v-bind="$attrs" :value="modelvalue" @input="oninput"
               :placeholder="placeholder" :id="id"  
               :disabled="props.disabled" :name="props.name"  autocomplete="off" :class="dinamycInput"
               @click="props.onclick" /> 
            <input ref="inputRef" v-if="props.type === 'password'" @change="validate"
               :type="type == 'password' && !isPasswordVisible ? 'password' : 'text'" :placeholder="placeholder" v-bind="$attrs" :value="modelvalue" @input="oninput"
               :id="id"  :disabled="disabled" :name="name"
               autocomplete="off" :class="dinamycInput" @click="props.onclick">
            <div v-if="type == 'password'" class="div-icon" @click="onclickIcon" :class="dinamycIcon">
               <img width="auto" height="auto" class="icon-eye" v-if="!isPasswordVisible" :src="eye1" alt="icono"
                  aria-label="Ícono para habilitar vista de texto" />
               <img width="auto" height="auto" v-else :src="eye2" class="icon-eye" alt="icono"
                  aria-label="Ícono para habilitar vista de texto" />
            </div>
         </div>
         <div class="input-label2" v-if="props.label2">
            <label>{{ props.label2 }}</label>
         </div>
      </section>
   </div>
</template>
<script>
// use normal <script> to declare options
export default {
   inheritAttrs: false
}
</script>
<script setup>
import '../../assets/css/config.css';
import eye1 from '../../assets/icons/eye1.png';
import eye2 from '../../assets/icons/eye2.png';
import { defineProps, ref, computed,  defineEmits } from 'vue';
const props = defineProps({
   type: { type: String, default: 'text' },
   id: { type: String, },
   placeholder: { type: String, default: 'placeholder' },
   validate: { type: RegExp, },   //expresion regular para validar la entrada en el elemento
   error: { type: String, default: '' }, //mensaje de errror de validacion del input
   positionerror: { type: String, default: '' },
   disabled: { type: Boolean, default: false },
   label: { type: String, },
   positionlabel: { type: String, default: 'left', }, // top, bottom, left, right      
   label2: { type: String, },
   onclickLabel2: { type: Function, },
   icon: { type: String, },
   lefticon: { type: Boolean, default: false, }, //  left, right
   onclick: { type: Function, },
   name: { type: String, },
   // value: { type: String, default: '' },
   insideicon: { type: Boolean, default: false },
   onclickicon: { type: Function, },
   Variant: { type: String, default: 'default' },
   modelvalue: {
      type: String,
   }
});
const errorMessage = ref('')
const wrapperRef = ref(null)
const inputRef = ref(null);
const value = ref(props.value);
const isPasswordVisible = ref(false);
const onclickIcon = () => {
   if (props.type === 'password') {
      isPasswordVisible.value = !isPasswordVisible.value;
   }
};
const emits = defineEmits(['update:modelvalue']);
const oninput = (event) => {
   emits('update:modelvalue', event.target.value);
}
const validate = () => {
   if (props.validate) {
      const result = props.validate.test(value.value)
      if (!result) {
         errorMessage.value = props.error
      } else {
         errorMessage.value = ''
      }
      if (value.value === "") {
         errorMessage.value = ''
      }
   }
};
// obligatorio  que props.onclickIcon sea 'changePasswordToText' para realiza el cambio de password a text
const claseDinamica = computed(() => {
   return {
      [`${props.lefticon ? 'positionIcon-left' : ''} `]: true
   }
})
const dinamycIcon = computed(() => {
   return {
      [`${props.insideicon && props.lefticon === false ? 'inside-icon-right' : ''}  ${props.insideicon && props.lefticon ? 'inside-icon-left' : ''}`]: true
   }
})
const dinamycInput = computed(() => {
   return {
      [` ${props.insideicon && props.lefticon ? 'indent' : ''}, input-variant-${props.Variant} `]: true
   }
})
</script>
<style>
.input-wrapper {
   position: relative;
    width: 100%;
}

.input-container {
   font-family: Rubik, sans-serif;
}

.input-flex {
   display: flex;
   flex-direction: column;
}

.input-label2 {
   text-align: end;
}

.input-label-top {
   text-align: start !important;
}

.error {
   color: red;
   font-size: 11px;
   position: absolute;
   transform: translateY(-18px);
   text-align: end;
}

.icon {
   position: absolute;
   right: 10px
}

.positionIcon-left {
   flex-direction: row-reverse;
   width: auto;
   justify-content: flex-end;
}

.inside-icon-right {
   transform: translateX(-25px);
}

.inside-icon-left {
   position: absolute;
}


.input-variant-default {
   -webkit-appearance: none;
   -moz-appearance: none;
   appearance: none;
   width: 100%;
   height: 40px;
   border-radius: 8px;
   border: 1px solid #CDCED9;
   background: transparent;
   background-color: white;
   cursor: pointer;
   font-family: Rubik, sans-serif;
   font-size: medium;
   padding-left: 16px;
   box-sizing: border-box;
}



.icon-eye {
   transform: translateX(-3px) translateY(-33px);
   position: absolute;
   right: 10px;   
   z-index: 1;
   cursor: pointer;
   pointer-events: auto;
   font-size: 16px;
}

.input-variant-default:focus {
   outline: none;
}
</style>

